var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{staticClass:"pl-4 pt-4 pr-4 pb-2"},[_vm._v("Inhaltsverzeichnis")]),_c('table-of-contents-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }